var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-circle overflow-hidden",style:({
    minWidth: (_vm.size + "px"),
    width: (_vm.size + "px"),
    height: (_vm.size + "px")
  })},[(_vm.img === null)?_c('div',{staticClass:"bg-dark text-white font-weight-bold text-center text-uppercase",style:({
      fontSize: ((_vm.size * 0.32) + "px"),
      lineHeight: (_vm.size + "px")
    })},[_vm._v(" "+_vm._s(_vm.abbreviation)+" ")]):_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img,"alt":"test"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }